<template>
  <v-menu v-model="menu" :close-on-content-click="false" min-width="200px" :nudge-bottom="10" offset-y left transition="slide-y-transition">
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip v-if="compact" bottom transition="scale-transition">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn class="mr-1 mt-n1" v-bind="attrs" v-on="{ ...on, ...tooltip }" color="secondary" icon small :ripple="false"><v-icon size="20">mdi-code-json</v-icon></v-btn>
        </template>
        <span>Insertar variable</span>
      </v-tooltip>
      <v-btn class="ml-1" v-else v-bind="attrs" v-on="on" color="secondary" outlined :ripple="false">Insertar variable<v-icon right>mdi-menu-down</v-icon></v-btn>
    </template>
    <v-list class="pa-0">
      <v-list-item class="px-5 py-1" v-for="d in tokens" @click="select(d)" :key="d.value">
        <v-list-item-title class="subtitle-2 font-weight-medium">{{d.label}}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { tokensForField } from '@/utils/reminders/tokens'

export default {
  props: {
    field: {
      type: String,
      required: false,
      default: () => ('message')
    },
    kind: {
      type: String,
      required: false,
      default: () => ('collection')
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    menu: false
  }),
  computed: {
    tokens () {
      return tokensForField(this.field, this.kind)
    }
  },
  methods: {
    select (token) {
      this.menu = false
      this.$emit('select', token.value)
    }
  }
}
</script>
